import { SideMarker } from "./tokens";

/**
 * Side markers only. Player identity is a generated face (AvatarFace), so the
 * geometric player marks are gone — two visual systems for "who is this" was
 * one too many.
 *
 * Drawn rather than emoji, so they render identically on every phone.
 */

/** Up for the top option, down for the bottom. Position reinforces colour. */
export const SideChevron = ({
  marker,
  color,
  size = 20,
}: {
  marker: SideMarker;
  color: string;
  size?: number;
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path
      d={marker === SideMarker.Up ? "M12 6l8 10H4z" : "M12 18L4 8h16z"}
      fill={color}
    />
  </svg>
);
